<template>
    <div>
        <button class="btn btn-primary" @click="openCommLogModal()">Log Communication</button>
        <comm-log-modal ref="commLogModal"></comm-log-modal>
    </div>
</template>


<script setup>
    import { ref } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useCommLogsStore } from '../../stores/comm-logs-store'
    import CommLogModal from './CommLogModal.vue'
    import moment from 'moment'

    const { commLog } = storeToRefs(useCommLogsStore())
    const { setSender, setRecipient, setCommReasons, setCommStatuses, fetchChannels } = useCommLogsStore()
    const props = defineProps(['sender', 'senderRoles', 'senderType', 'recipient', 'recipientType', 'commReasons', 'commStatuses'])

    setSender(props.sender, props.senderRoles, props.senderType)
    setRecipient(props.recipient, props.recipientType)
    setCommReasons(props.commReasons)
    setCommStatuses(props.commStatuses)

    // open modal to manage channels
    let commLogModal = ref(null)
    function openCommLogModal () {
        commLogModal.value.show()
        fetchChannels()
    }
</script>